// UI controls — ports MobileMenu, SearchBox, SortSelect,
// Gallery and AccessibilityWidget from the old React components.
(() => {
  const { routes } = window.mizu;

  // MobileMenu: drawer from the inline-start edge; page scroll locked while open.
  function setupDrawer() {
    const drawer = document.querySelector('[data-mizu-drawer]');
    const opener = document.querySelector('[data-mizu-menu-open]');
    if (!drawer || !opener) return;
    let prevOverflow = '';
    const set = (open) => {
      drawer.hidden = !open;
      opener.setAttribute('aria-expanded', String(open));
      if (open) { prevOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
      else document.body.style.overflow = prevOverflow;
    };
    const main = document.getElementById('main');
    const closeBtn = drawer.querySelector('[data-mizu-menu-close]');
    const toggle = (open) => {
      set(open);
      if (main) main.inert = open; // keep Tab inside the open drawer
      (open ? closeBtn : opener)?.focus();
    };
    opener.addEventListener('click', () => toggle(true));
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer || e.target.closest('[data-mizu-menu-close]') || e.target.closest('a')) toggle(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) toggle(false);
    });
  }

  // SearchBox: live search, debounced 300ms. On the search page the results
  // section is swapped in place (history.replaceState); elsewhere it navigates.
  function searchUrl(q) {
    const t = q.trim();
    return t ? `${routes.search}?q=${encodeURIComponent(t)}&type=product&options%5Bprefix%5D=last` : routes.search;
  }
  let swapSeq = 0;
  async function liveSwap(url) {
    const seq = ++swapSeq;
    const box = document.querySelector('[data-mizu-search-results]');
    const sep = url.includes('?') ? '&' : '?';
    const res = await fetch(`${url}${sep}section_id=${box.dataset.sectionId}`);
    const html = await res.text();
    if (seq !== swapSeq) return; // a newer query already answered; never show stale results
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mizu-search-results]');
    if (fresh) box.innerHTML = fresh.innerHTML;
    document.dispatchEvent(new Event('mizu:swap')); // re-sync wishlist hearts on the new cards
    history.replaceState(null, '', url);
  }
  const CARRY = 'mizu-search-carry';
  function setupSearch() {
    const form = document.querySelector('[data-mizu-search]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    const onSearchPage = () => !!document.querySelector('[data-mizu-search-results]');
    // The old SearchBox lived in the persistent layout: text typed on another
    // page stayed in the (focused) box after landing on the search page, while a
    // fresh load started empty. Carry the typed text across the page load.
    const go = (q) => {
      if (onSearchPage()) return liveSwap(searchUrl(q)).catch(() => location.assign(searchUrl(q)));
      try { sessionStorage.setItem(CARRY, q); } catch {}
      location.assign(searchUrl(q));
    };
    let timer;
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => go(input.value), 300); });
    form.addEventListener('submit', (e) => { e.preventDefault(); clearTimeout(timer); go(input.value); });
    let carried = null;
    try { carried = sessionStorage.getItem(CARRY); sessionStorage.removeItem(CARRY); } catch {}
    if (onSearchPage() && carried) {
      input.value = carried;
      input.focus();
      input.setSelectionRange(carried.length, carried.length);
    }
  }

  function setupSort() {
    document.querySelector('[data-mizu-sort]')?.addEventListener('change', (e) => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', e.target.value);
      location.assign(url);
    });
  }


  // Gallery: photo thumbnails + optional video tab.
  function setupGallery(g) {
    const slides = g.querySelectorAll('[data-gallery-slide]');
    const thumbs = g.querySelectorAll('[data-gallery-thumb]');
    const video = g.querySelector('[data-gallery-video]');
    const tab = g.querySelector('[data-gallery-video-tab]');
    const show = (index) => {
      slides.forEach((s) => { s.hidden = Number(s.dataset.gallerySlide) !== index; });
      thumbs.forEach((t) => {
        const on = Number(t.dataset.galleryThumb) === index;
        t.setAttribute('aria-pressed', String(on));
        t.classList.toggle('ring-water', on);
        t.classList.toggle('ring-transparent', !on);
      });
      if (video) video.hidden = index !== -1;
      if (tab) {
        tab.classList.toggle('bg-ink', index === -1); tab.classList.toggle('text-paper', index === -1);
        tab.classList.toggle('bg-mist', index !== -1); tab.classList.toggle('text-stone', index !== -1);
      }
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.galleryThumb))));
    tab?.addEventListener('click', () => show(-1));
  }

  function setupShelf(section) {
    const track = section.querySelector('[data-mizu-shelf-track]');
    const buttons = section.querySelectorAll('[data-mizu-shelf-move]');
    if (!track) return;
    const update = () => {
      const distance = Math.abs(track.scrollLeft);
      const end = track.scrollWidth - track.clientWidth;
      buttons.forEach((button) => {
        button.disabled = Number(button.dataset.mizuShelfMove) < 0 ? distance < 2 : distance >= end - 2;
      });
    };
    buttons.forEach((button) => button.addEventListener('click', () => {
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches
        || document.documentElement.classList.contains('a11y-motion')
        || document.documentElement.dataset.motion === 'static';
      const direction = document.documentElement.dir === 'rtl' ? -1 : 1;
      track.scrollBy({
        left: direction * Number(button.dataset.mizuShelfMove) * track.clientWidth * .85,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }));
    track.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update, { passive: true });
    update();
  }

  setupDrawer();
  setupSearch();
  setupSort();
  document.querySelectorAll('[data-mizu-gallery]').forEach(setupGallery);
  document.querySelectorAll('[data-mizu-shelf]').forEach(setupShelf);
})();
